import React, { useState } from 'react';
import { Star, Quote, ChevronLeft, ChevronRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const Testimonials = () => {
  const { language, t } = useLanguage();
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'Prakhar Srivastava',
      rating: 5,
      date: { en: 'November 2024', bn: 'নভেম্বর ২০২৪' },
      review: {
        en: 'The homestay is located in the heart of Vrindavan, with major temples within just 100-500 meters. The place is clean, peaceful, and well-maintained. The hosts (uncle and aunt) are incredibly warm and welcoming. Truly a wonderful stay.',
        bn: 'হোমস্টে বৃন্দাবনের হৃদয়ে অবস্থিত, প্রধান মন্দিরগুলি মাত্র ১০০-৫০০ মিটারের মধ্যে। জায়গাটি পরিষ্কার, শান্তিপূর্ণ এবং সুরক্ষিত। হোস্টরা (কাকা এবং কাকী) অবিশ্বাস্যভাবে উষ্ণ এবং স্বাগত জানায়। সত্যিই একটি দুর্দান্ত থাকা।'
      },
      highlight: { en: 'Rooms: 5/5 • Service: 5/5 • Location: 5/5', bn: 'কক্ষ: ৫/৫ • সেবা: ৫/৫ • অবস্থান: ৫/৫' }
    },
    {
      name: 'Liza 91',
      rating: 5,
      date: { en: 'November 2024', bn: 'নভেম্বর ২০২৪' },
      review: {
        en: 'The home stay is good for family night stay. The room & wash rooms are very clean and hygienic. Behaviour of owner is very good. He is helpful and arranges for any kind of needs his guests ask for. Location of homestay is prime. All temples and transportation accessible from here along with market place. Added bonus:- The owner understands bengali!',
        bn: 'হোমস্টে পরিবারের রাত্রিযাপনের জন্য ভাল। কক্ষ এবং ওয়াশরুম খুব পরিষ্কার এবং স্বাস্থ্যকর। মালিকের আচরণ খুব ভাল। তিনি সাহায্যকারী এবং অতিথিদের যেকোনো প্রয়োজন পূরণ করেন। হোমস্টের অবস্থান প্রধান। সমস্ত মন্দির এবং পরিবহন এখান থেকে সহজলভ্য। বিশেষ সুবিধা:- মালিক বাংলা বোঝেন!'
      },
      highlight: { en: 'Perfect for Bengali families', bn: 'বাঙালি পরিবারের জন্য নিখুঁত' }
    },
    {
      name: 'Arijeet Ash',
      rating: 4,
      date: { en: 'October 2024', bn: 'অক্টোবর ২০২৪' },
      review: {
        en: 'The homestay is exceptionally well located in old vrindavan. Mr Sharma the owner is a very gentle man. You\'ll always find him whenever there is need. He is more of like a family guide. Get in some dusk talks with him and he\'ll tell you the stories of Kunj, vrindavan and shri krishn. The rooms are very good and the place is near to all places.',
        bn: 'হোমস্টে পুরাতন বৃন্দাবনে ব্যতিক্রমীভাবে ভাল অবস্থানে। মালিক মি. শর্মা খুবই ভদ্র মানুষ। যখনই প্রয়োজন তাকে পাবেন। তিনি পরিবারের গাইডের মতো। সন্ধ্যায় তার সাথে কথা বলুন এবং তিনি আপনাকে কুঞ্জ, বৃন্দাবন এবং শ্রী কৃষ্ণের গল্প বলবেন। কক্ষগুলি খুব ভাল এবং জায়গাটি সব জায়গার কাছে।'
      },
      highlight: { en: 'Service: 5/5 • Location: 5/5', bn: 'সেবা: ৫/৫ • অবস্থান: ৫/৫' }
    },
    {
      name: 'Isika Chowdhury',
      rating: 5,
      date: { en: 'October 2024', bn: 'অক্টোবর ২০২৪' },
      review: {
        en: 'Place is very good. We took 2 rooms and both rooms were excellent. Kitchen is also available. You can cook your own food if you want. Attached bathroom with AC and geyser. Everything is excellent. I really liked it.',
        bn: 'জায়গাটি খুব ভাল। আমরা ২টি রুম নিয়েছিলাম এবং দুটি রুমই চমৎকার ছিল। রান্নাঘরও আছে। চাইলে নিজের খাবার রান্না করতে পারবেন। সংযুক্ত বাথরুম এসি এবং গিজার সহ। সবকিছু দুর্দান্ত। আমার সত্যিই ভাল লেগেছে।'
      },
      highlight: { en: 'Rooms: 5/5 • Service: 5/5 • Location: 5/5', bn: 'কক্ষ: ৫/৫ • সেবা: ৫/৫ • অবস্থান: ৫/৫' }
    },
    {
      name: 'Siva Teja Mundlamuri',
      rating: 5,
      date: { en: 'December 2024', bn: 'ডিসেম্বর ২০২৪' },
      review: {
        en: 'The owner is exceptionally good and hospitable. The room offered the best price and was fully equipped with all the necessary amenities, including a geyser and Wi-Fi. I stayed for four days and did not encounter any issues. The environment was very friendly, and the atmosphere was very welcoming.',
        bn: 'মালিক ব্যতিক্রমী ভাল এবং আতিথেয়তাপূর্ণ। রুমটি সেরা মূল্যে ছিল এবং গিজার এবং ওয়াই-ফাই সহ সমস্ত প্রয়োজনীয় সুবিধা দিয়ে সজ্জিত ছিল। আমি চার দিন ছিলাম এবং কোনও সমস্যার সম্মুখীন হইনি। পরিবেশ খুব বন্ধুত্বপূর্ণ ছিল এবং পরিবেশ খুব স্বাগত ছিল।'
      },
      highlight: { en: 'Wi-Fi • Best Price • Friendly', bn: 'ওয়াই-ফাই • সেরা মূল্য • বন্ধুত্বপূর্ণ' }
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <div className="h-px w-12 bg-orange-400" />
              <div className="w-2 h-2 rotate-45 bg-orange-400" />
              <div className="h-px w-12 bg-orange-400" />
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              {language === 'bn' ? 'অতিথিদের মতামত' : 'Guest Reviews'}
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              {language === 'bn' 
                ? 'আমাদের অতিথিরা কী বলেন তা দেখুন' 
                : 'See what our guests say about us'}
            </p>

            {/* Google Rating Badge */}
            <div className="flex items-center justify-center space-x-2 mb-4">
              <div className="flex items-center space-x-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <span className="text-2xl font-bold text-gray-800">4.6</span>
              <span className="text-gray-600">
                {language === 'bn' ? '(১৯০টি রিভিউ)' : '(190 reviews)'}
              </span>
            </div>

            {/* Google Profile Link */}
            <Button
              onClick={() => window.open('https://share.google/Pa1S5iKSDnusvwYLJ', '_blank')}
              variant="outline"
              size="sm"
              className="border-orange-300 text-orange-600 hover:bg-orange-50"
            >
              <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" />
              </svg>
              {language === 'bn' ? 'সমস্ত রিভিউ দেখুন' : 'View All Reviews on Google'}
            </Button>
          </div>

          {/* Testimonial Carousel */}
          <div className="relative">
            <Card className="border-2 border-orange-100 shadow-2xl bg-white overflow-hidden">
              <CardContent className="p-8 md:p-12">
                <div className="flex flex-col items-center text-center">
                  {/* Quote Icon */}
                  <div className="w-16 h-16 rounded-full bg-gradient-to-br from-orange-500 to-red-500 flex items-center justify-center mb-6 shadow-lg">
                    <Quote className="w-8 h-8 text-white" />
                  </div>

                  {/* Stars */}
                  <div className="flex items-center space-x-1 mb-4">
                    {[...Array(5)].map((_, i) => (
                      <Star 
                        key={i} 
                        className={`w-6 h-6 ${
                          i < currentTestimonial.rating 
                            ? 'fill-yellow-400 text-yellow-400' 
                            : 'fill-gray-200 text-gray-200'
                        }`} 
                      />
                    ))}
                  </div>

                  {/* Review Text */}
                  <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6 max-w-3xl">
                    "{currentTestimonial.review[language]}"
                  </p>

                  {/* Highlight */}
                  <div className="inline-block px-4 py-2 bg-orange-50 rounded-full mb-6">
                    <p className="text-sm font-medium text-orange-600">
                      {currentTestimonial.highlight[language]}
                    </p>
                  </div>

                  {/* Reviewer Info */}
                  <div className="border-t border-gray-200 pt-6 w-full max-w-md">
                    <h4 className="text-xl font-bold text-gray-800 mb-1">
                      {currentTestimonial.name}
                    </h4>
                    <p className="text-gray-500 text-sm">
                      {currentTestimonial.date[language]}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Navigation Buttons */}
            <div className="flex items-center justify-center space-x-4 mt-8">
              <Button
                onClick={prevTestimonial}
                variant="outline"
                size="lg"
                className="rounded-full w-14 h-14 border-2 border-orange-300 hover:bg-orange-50 hover:border-orange-400 transition-all"
              >
                <ChevronLeft className="w-6 h-6 text-orange-600" />
              </Button>

              {/* Indicators */}
              <div className="flex space-x-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    className={`h-2 rounded-full transition-all ${
                      index === currentIndex 
                        ? 'w-8 bg-orange-500' 
                        : 'w-2 bg-gray-300 hover:bg-orange-300'
                    }`}
                  />
                ))}
              </div>

              <Button
                onClick={nextTestimonial}
                variant="outline"
                size="lg"
                className="rounded-full w-14 h-14 border-2 border-orange-300 hover:bg-orange-50 hover:border-orange-400 transition-all"
              >
                <ChevronRight className="w-6 h-6 text-orange-600" />
              </Button>
            </div>
          </div>

          {/* Trust Indicators */}
          <div className="grid md:grid-cols-3 gap-6 mt-16">
            <Card className="border border-orange-100 bg-gradient-to-br from-orange-50 to-white text-center p-6">
              <div className="text-3xl font-bold text-orange-600 mb-2">190+</div>
              <p className="text-gray-600">
                {language === 'bn' ? 'গুগল রিভিউ' : 'Google Reviews'}
              </p>
            </Card>
            <Card className="border border-orange-100 bg-gradient-to-br from-orange-50 to-white text-center p-6">
              <div className="text-3xl font-bold text-orange-600 mb-2">4.6★</div>
              <p className="text-gray-600">
                {language === 'bn' ? 'গড় রেটিং' : 'Average Rating'}
              </p>
            </Card>
            <Card className="border border-orange-100 bg-gradient-to-br from-orange-50 to-white text-center p-6">
              <div className="text-3xl font-bold text-orange-600 mb-2">100%</div>
              <p className="text-gray-600">
                {language === 'bn' ? 'সন্তুষ্ট অতিথি' : 'Satisfied Guests'}
              </p>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
